import React from 'react'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
// import { DefinitionsList } from 'content'
import './ToggleDefinitionModal.css'

class ToggleDefinitionModal extends React.Component {
  render(){
    const definition = {}//DefinitionsList.find((item) => item.id === this.props.id)

    return (
      <a onClick={e => this.props.app.toggleModal(e, 'definition-id', definition)}>{this.props.label}</a>
    )
  }
}

export default withApp(ToggleDefinitionModal)
